import { Box, Grid, Typography } from "@mui/material";
import React from "react";

export default function FinanceStaticstic() {
  return (
    <Grid container>
      <Grid
        xs={12 / 2}
        md={4}
        item
        sx={{ borderRadius: "6px" }}
      >
        <Box sx={{ p: "12px", m: "12px", background: "var(--Delivered)" }}>
          {" "}
          <Typography sx={{ fontSize: "12px" }}>
            Tổng công nợ <strong>KHO:</strong>
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", color: "var(--Delivered-txt)" }}
          >
            1.286.000.000đ
          </Typography>
        </Box>
      </Grid>
      <Grid
        xs={12 / 2}
        md={4}
        item
        sx={{ borderRadius: "6px" }}
      >
        <Box sx={{ p: "12px", m: "12px", background: "var(--success)" }}>
          <Typography sx={{ fontSize: "12px" }}>
            Đã thanh toán <strong>KHO:</strong>
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", color: "var(--success-txt)" }}
          >
            1.286.000.000đ
          </Typography>
        </Box>
      </Grid>
      <Grid
        xs={12 / 2}
        md={4}
        item
        sx={{ borderRadius: "6px" }}
      >
        <Box sx={{ p: "12px", m: "12px", background: "var(--reject)" }}>
          {" "}
          <Typography sx={{ fontSize: "12px" }}>
            Chưa thanh toán <strong>KHO:</strong>
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", color: "var(--reject-txt)" }}
          >
            1.286.000.000đ
          </Typography>
        </Box>
      </Grid>
      <Grid
        xs={12 / 2}
        md={4}
        item
        sx={{ borderRadius: "6px" }}
      >
        <Box sx={{ p: "12px", m: "12px", background: "var(--Delivered)" }}>
          <Typography sx={{ fontSize: "12px" }}>
            Tổng công nợ <strong>SALE:</strong>{" "}
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", color: "var(--Delivered-txt)" }}
          >
            1.286.000.000đ
          </Typography>
        </Box>
      </Grid>
      <Grid
        xs={12 / 2}
        md={4}
        item
        sx={{ borderRadius: "6px" }}
      >
        <Box sx={{ p: "12px", m: "12px", background: "var(--success)" }}>
          <Typography sx={{ fontSize: "12px" }}>
            Đã thanh toán <strong>SALE:</strong>
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", color: "var(--success-txt)" }}
          >
            1.286.000.000đ
          </Typography>
        </Box>
      </Grid>
      <Grid
        xs={12 / 2}
        md={4}
        item
        sx={{ borderRadius: "6px" }}
      >
        <Box sx={{ p: "12px", m: "12px", background: "var(--reject)" }}>
          <Typography sx={{ fontSize: "12px" }}>
            Chưa thanh toán <strong>SALE:</strong>
          </Typography>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", color: "var(--reject-txt)" }}
          >
            1.286.000.000đ
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
